import React, { Component } from "react";
import axios from 'axios';
import './listing.css';
import ListingDisplay from "./listingDisplay";
import CategoryFilter from "../filters/categoryfilter";
import PriceFilter from "../filters/costfilter";
import Header from "../../Header";
const url = "https://bwapi.onrender.com/catbike?categoryId="

class listingApi extends Component {
    constructor() {
        super()
        this.state = {
            categorylist: ''
        }
    }
    setDataPerFilter=(data)=>{
        this.setState({categorylist:data})
    }
    render() {
        return (
            <>
            <Header />
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-3 " style={{ border: "red" }}>
                            <a href="index.html">
                                <p> Home | <b>All Brands</b></p>
                            </a>
                            <div class="border-bottom pb-2 ml-2">
                                <h4 id="burgundy">Filters</h4>
                            </div>
                            <CategoryFilter Brand_id={ this.props.match.params.Brand_id}
                            categoryPerFilter={(data)=>{this.setDataPerFilter(data)}}/>
                            <PriceFilter category={ this.props.match.params.category}
                            categoryPerPrice={(data)=>{this.setDataPerFilter(data)}}/>
                        </div>
                        <div class="col-md-9">


                            <div class="row ">

                                <ListingDisplay listData={this.state.categorylist} />
                            </div>
                        </div>
                    </div>
                </div>


            </>

        )
    }
    componentDidMount() {
        let categoryId = this.props.match.params.categoryId;
        sessionStorage.setItem('categoryId', categoryId);
        axios.get(`${url}${categoryId}`, { method: 'GET' })
        .then((res) => { this.setState({ categorylist: res.data }) })
    }

}
export default listingApi;